// @ts-expect-error pure js
import TextInput from "../../UI/TextInput";
// @ts-expect-error pure js
import Tabs from "../../UI/Tabs";
import Button from "../../UI/Button";
import Callout from "../../UI/Callout";
import { useFormikContext } from "formik";
import { useEffect } from "react";
import styles from "./NbAppartements.module.css";

const APPARTEMENT_DEFAULT = {
  nom: "",
  id_lease_template: "",
  nb_pieces_principales: "",
  surface_total: "",
  loyer_hc: "",
  charges: "",
  deposit: "",
};

export default function NbAppartements() {
  const { selectNextTab, selectPreviousTab } = Tabs.useActiveTab();
  const { values, setFieldValue } = useFormikContext<{
    nb_rooms: number | string;
    appartements: (typeof APPARTEMENT_DEFAULT)[];
  }>();

  const nbRooms = parseInt(String(values.nb_rooms)) || 0;

  useEffect(() => {
    const currentLength = values.appartements?.length || 0;
    if (nbRooms === currentLength) return;

    if (nbRooms > currentLength) {
      const newApparts = [...(values.appartements || [])];
      for (let i = currentLength; i < nbRooms; i++) {
        newApparts.push({
          ...APPARTEMENT_DEFAULT,
          nom: `Appartement ${String(i + 1).padStart(2, "0")}`,
        });
      }
      setFieldValue("appartements", newApparts);
    } else if (nbRooms < currentLength) {
      setFieldValue("appartements", values.appartements.slice(0, nbRooms));
    }
  }, [nbRooms, setFieldValue, values.appartements]);

  return (
    <div className={styles.step}>
      <Callout variant="warning">
        D'un point de vue de l'abonnement, chaque appartement comptera comme un
        bien à part entière. Vous pourrez personnaliser le nom et les détails de
        chaque appartement après les avoir créés.
      </Callout>
      <Callout variant="success">
        {nbRooms > 0
          ? "Dans les prochaines étapes, vous allez configurer chaque appartement individuellement (loyer, charges, surface, etc.), ainsi que les équipements communs de l'immeuble."
          : "Si vous ne souhaitez pas créer d'appartements maintenant, seul l'immeuble (dossier) sera créé. Vous pourrez ajouter des appartements plus tard."}
      </Callout>
      <TextInput
        name={"nb_rooms"}
        type={"number"}
        label={"Nombre d'appartements à créer"}
        mandatory
      />
      <div className={styles.footer}>
        <Button variant="secondary" onClick={() => selectPreviousTab()}>
          Précédent
        </Button>
        <Button onClick={() => selectNextTab()}>Suivant</Button>
      </div>
    </div>
  );
}
